// PhoneVerifyRewardHandler.js
'use strict';
import { connect } from 'react-redux';

import addPopupNotification from '../action/addPopupNotification.js';
import fetchReferralRedeemStatus from '../action/fetchReferralRedeemStatus.js';
import fetchAccountLinks from '../action/fetchAccountLinks.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLoginData from '../selector/getLoginData.js';
import { ADD_NOTIFICATIONS } from '../ActionTypes.js';

import {
  FEATURE_PHONE_VERIFY_REWARD_NOTIFICATION_COOLDOWN_MSEC,
  OEMBED_REFERRAL_PENDING_REDEMPTION_TEMPLATE_ID,
} from '../RemoteConfigKeys.js';

import PhoneVerifyRewardHandler from '../component/PhoneVerifyRewardHandler.jsx';

const mapStateToProps = state => {
  return {
    token: getMeData(state, 'token'),
    isPhoneBound: getMeData(state, 'isPhoneBound'),
    isFromRegisterEntry: getLoginData(state, 'entry') === 'register',
    oembedReferralPendingRedemptionTemplateId: getRemoteConfigData(
      state,
      OEMBED_REFERRAL_PENDING_REDEMPTION_TEMPLATE_ID
    ),
    phoneVerifyRewardNotificationCooldownMsec: getRemoteConfigData(
      state,
      FEATURE_PHONE_VERIFY_REWARD_NOTIFICATION_COOLDOWN_MSEC
    ),
    isPendingReferralRedemption: getMeData(
      state,
      'isPendingReferralRedemption'
    ),
    isMeAccountLinksFetched: getNetworkingData(
      state,
      ['me', 'accountLinks'],
      'isFetched'
    ),
    isMeAccountLinksFetching: getNetworkingData(
      state,
      ['me', 'accountLinks'],
      'isFetching'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAccountLinks: () => dispatch(fetchAccountLinks()),
    fetchReferralRedeemStatus: () => dispatch(fetchReferralRedeemStatus()),
    addPopupNotification: ({ id, position, link, tag, isNotificationCenter }) =>
      dispatch(
        addPopupNotification({
          id,
          position,
          link,
          tag,
          isNotificationCenter,
        })
      ),
    addNotificationCenterItem: payload =>
      dispatch({
        type: ADD_NOTIFICATIONS,
        payload: { notifications: payload },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhoneVerifyRewardHandler);
